const header = {
  homepage: 'https://rodrigoguzman83.github.io/my-portfolio',
  title: 'RG.',
}

const about = {
  name: 'Luis Rodrigo Guzman',
  role: 'Full Stack Engineer',
  description:
    "I am a developer with +6 years of experience in BACKEND, as well as FRONTEND, DATA BASES & QA. I have a positive mindset, good communication skills and a very proactive and versatile approach. I love working with multi-disciplinary teams, and I focus on results. With my experience and my background, we will be able to achieve the corporate goals to improve the company performance and to optimize the company's systems",
  resume:
    'https://drive.google.com/file/d/17J0qM6UI3UcH-LCvKaLiA3k_HaDH9uyM/view?usp=sharing',
  social: {
    linkedin: 'https://www.linkedin.com/in/rodrigoluisguzman/',
    github: 'https://github.com/rodrigoguzman83',
    whatsapp: 'https://api.whatsapp.com/send?phone=+5491140365765',
  },
}

const projects = [
  {
    name: 'CRUD with Laravel',
    description:
      'It´s a simple App to manage your articles and facilitate advanced interaction controls',
    stack: ['Laravel', 'MySql', 'Bootstrap', 'DataTable'],
    sourceCode:
      'https://github.com/rodrigoguzman83/CRUD_Laravel_Bootstrap_Datatable',
    /** livePreview: 'https://github.com' */
  },
  {
    name: 'Travel APP',
    description: 'It´s a simple App to manage your trips',
    stack: ['Laravel', 'MySql', 'Bootstrap'],
    sourceCode: 'https://github.com/rodrigoguzman83/agencia-app',
    /** livePreview: 'https://github.com' */
  },
  {
    name: 'Product APP',
    description: 'It´s a simple App to manage your products',
    stack: ['Laravel', 'MySql', 'Bootstrap'],
    sourceCode: 'https://github.com/rodrigoguzman83/catalogo-app',
    /** livePreview: 'https://github.com' */
  },
  {
    name: 'My Portfolio',
    description: 'It´s my personal portfolio made with REACT',
    stack: ['Html', 'CSS', 'JavaScript', 'React', 'Material UI'],
    sourceCode: 'https://github.com/rodrigoguzman83/my-portfolio',
    livePreview: 'https://rodrigoguzman83.github.io/my-portfolio/',
  },
  {
    name: 'To Do List',
    description: 'It´s a simple To-Do List App made with REACT',
    stack: ['Html', 'CSS', 'JavaScript', 'React', 'React-Bootstrap'],
    sourceCode: 'https://github.com/rodrigoguzman83/toDoListFirstVersion',
    livePreview: 'https://elegant-wright-5ea92f.netlify.app/',
  },
  {
    name: 'Tweet List App',
    description:
      'It´s a simple Tweets List App made with Javascript using Local Storage',
    stack: ['Html', 'CSS', 'JavaScript'],
    sourceCode: 'https://github.com/rodrigoguzman83/project-local-storage',
    livePreview: 'https://project-local-storage-m8w1m4ahr.vercel.app/',
  },
]

const skills = [
  'HTML',
  'CSS',
  'JavaScript',
  'Bootstrap',
  'React',
  'Vue',
  'PHP',
  'Python',
  'Node',
  'Laravel',
  'Slim',
  'Express',
  'Nest',
  'Flask',
  'SQL Server',
  'MySQL',
  'Oracle',
  'MongoDB',
  'Git',
  'Docker',
  'AWS',
]

const contact = {
  email: 'rodrigoluisguzman@gmail.com',
}

export { header, about, projects, skills, contact }
